import React, { forwardRef } from 'react';

import classnames from 'classnames';

import { Avatar } from '../../Avatar';

import styles from '../Chip.module.scss';

type Props = {
    alt: string;
    avatar?: string;
    children?: React.ReactNode;
    className?: string;
};

export const AvatarChip = forwardRef<HTMLDivElement, Props>(
    ({ alt, avatar, children, className }, ref) => {
        return (
            <div className={classnames(styles.chip, styles['chip--avatar'], className)} ref={ref}>
                {avatar ? (
                    <Avatar alt={alt} image={avatar} noBorder size="small" />
                ) : (
                    <Avatar alt={alt} noBorder size="small" withInitials />
                )}

                {children}
            </div>
        );
    }
);

AvatarChip.displayName = 'AvatarChip';
